






import { Component, Vue } from 'vue-property-decorator';
import UserForm from '@/components/user/UserForm.vue';
import { Action } from 'vuex-class';

@Component({
  components: {
    UserForm,
  },
})
export default class UserAdd extends Vue {
  @Action('resetUserWorkflowAction') public resetUserWorkflowAction!: () => void;

  private mounted(): void {
    this.resetUserWorkflowAction();
  }
}
